/**
 * @desc 通过来源单号及平台获取退货商品
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBillFacadeImpl.loadBySpOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/loadBySpOrderNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
